'use client';

import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import useCardTheme from './themes';

type CardFooterProps = {
  children: React.ReactNode;
  className?: string;
};

function CardFooter({ children, className }: CardFooterProps) {
  const { footerClasses } = useCardTheme();

  return <div className={twMerge(footerClasses, className)}>{children}</div>;
}

export default CardFooter;
